import LogoFile from "../../file/model/societe/LogoFile";
import CachetFile from "../../file/model/societe/CachetFile";
import LangueService from "../../../i18n/service/LangueService";
export default  class Societe
{
    /**
     * @type {string} l'identifiant de la société
     */
    #_id;
    /**
     * @type {number} le timbre fiscal de la societe
     */
    #_timbreFiscal;

    /**
     * indique si la société est un client inscrit à la plateforme begro ou non
     * @type {boolean}
     */
    #_inscrit=false;

    /**
     * @type {LogoFile}
     */
    #_logoFile=null;

    /**
     * @type {CachetFile}
     */
    #_cachetFile=null;

    /**
     * traductions nom commercial
     * @type {{}}
     */
    #_nomCommercial={};


    get id() {
        return this.#_id;
    }

    set id(value) {
        this.#_id = value;
    }


    get timbreFiscal() {
        return this.#_timbreFiscal;
    }

    set timbreFiscal(value) {
        this.#_timbreFiscal = value;
    }


    getNomCommercial(locale)
    {
        return this.#_nomCommercial[locale];
    }



    set nomCommercial(value) {
        this.#_nomCommercial = value;
    }

    addNomCommercialTraduction(locale,nomCommercial)
    {
        this.#_nomCommercial[locale]=nomCommercial;
    }

    get logoFile() {
        return this.#_logoFile;
    }

    /**
     *
     * @param {?LogoFile} logoFile
     */
    set logoFile(logoFile) {
        this.#_logoFile = logoFile;
    }

    get cachetFile() {
        return this.#_cachetFile;
    }

    /**
     *
     * @param {?CachetFile}cachetFile
     */
    set cachetFile(cachetFile) {
        this.#_cachetFile = cachetFile;
    }


    get inscrit() {
        return this.#_inscrit;
    }

    set inscrit(value) {
        this.#_inscrit = value;
    }

    /**
     * méthode de classe qui permet de céer un nouveau objet vente depuis un json généré depuis objet societe java
     * @param {{}} societeJson
     * @returns {Societe}
     */
    static creatObjetFromJson(societeJson) {
        Begro.logInfo("######Début création de la société a partir de l'objet JSON: ",societeJson)
        let societe = new Societe();
        societe.id=societeJson.id;
        societe.timbreFiscal=societeJson.timbreFiscal
        societe.inscrit=societeJson.inscrit
        if(societeJson.hasOwnProperty("logoFile")&&societeJson.logoFile!=null)
        {
            societe.logoFile=LogoFile.createFromJson(societeJson.logoFile);
        }
        if(societeJson.hasOwnProperty("cachetFile")&&societeJson.cachetFile!==null)
        {
            societe.cachetFile=CachetFile.createFromJson(societeJson.cachetFile);
        }
        if(societeJson.hasOwnProperty("societeTraductions")&&societeJson.societeTraductions!==null)
        {
            for(let langue in LangueService.getInstance().langues)
            {
                let locale=langue.locale;
                if(societeJson.societeTraductions.hasOwnProperty(locale)) {
                    let traduction = societeJson.societeTraductions[locale];
                    societe.addNomCommercialTraduction(traduction[locale]['nomCommercial']);
                }
            }
        }
        Begro.logInfo("######fin création de la société a partir de l'objet JSON: ",societe)
        return societe;
    }

}